/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Seo_DescriptionInputs */

const en_privacy_policy_seo_description = /** @type {(inputs: Privacy_Policy_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How this product collects, uses, and protects your data.`)
};

const es_privacy_policy_seo_description = /** @type {(inputs: Privacy_Policy_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo este producto recopila, usa y protege tus datos.`)
};

const fr_privacy_policy_seo_description = /** @type {(inputs: Privacy_Policy_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment ce produit collecte, utilise et protège vos données.`)
};

/**
* | output |
* | --- |
* | "How this product collects, uses, and protects your data." |
*
* @param {Privacy_Policy_Seo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const privacy_policy_seo_description = /** @type {((inputs?: Privacy_Policy_Seo_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Seo_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_policy_seo_description(inputs)
	if (locale === "es") return es_privacy_policy_seo_description(inputs)
	return fr_privacy_policy_seo_description(inputs)
});